import React, { useState } from 'react';
import { Box, Container, Grid } from '@material-ui/core';
import { IAppDetailsView } from '../AppDetailsView';
import styled from 'styled-components';
import Lightbox from 'react-image-lightbox';

const StyledBox = styled(Box)`
    cursor: pointer;
    transition: all 0.2s linear;
    transform: scale(1);

    &:hover {
        transform: scale(1.02);
    }
`;

export const AppDetailsScreenshots = ({ listing }: IAppDetailsView) => {
    const [isOpen, setIsOpen] = useState<number>(-1);
    const images: string[] = Array.from(listing?.screenShots ?? []).map(img => img.image.sourceUrl);

    if (images.length <= 0) {
        return null;
    }

    return (
        <>
            {isOpen !== -1 && (
                <Lightbox
                    mainSrc={images[isOpen]}
                    nextSrc={images[(isOpen + 1) % images.length]}
                    prevSrc={images[(isOpen + images.length - 1) % images.length]}
                    onMoveNextRequest={() => setIsOpen((isOpen + 1) % images.length)}
                    onMovePrevRequest={() =>
                        setIsOpen((isOpen + images.length - 1) % images.length)
                    }
                    onCloseRequest={() => setIsOpen(-1)}
                />
            )}
            <Box>
                <Container>
                    <Box p={4} borderBottom={'1px solid #DDDDDD'}>
                        <Grid container spacing={4}>
                            <Grid sm={12} md={12} item>
                                <Box fontSize={'28px'} fontWeight={'300'}>
                                    Screenshots
                                </Box>
                            </Grid>
                            <Grid item sm={12} md={12}>
                                <Box display="flex" flexWrap="wrap" my={2}>
                                    {Array.from(listing.screenShots).map((screenShot, i) => (
                                        <StyledBox
                                            key={i}
                                            mr={2}
                                            mb={2}
                                            p={0}
                                            bgcolor={'#B5C6DF'}
                                            maxWidth={'240px'}
                                            maxHeight={'160px'}
                                            borderRadius={'5px'}
                                            display={'flex'}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                            onClick={() => setIsOpen(i)}
                                        >
                                            <img
                                                style={{
                                                    objectFit: 'contain',
                                                    maxHeight: '100%',
                                                    maxWidth: '100%',
                                                    borderRadius: '5px',
                                                }}
                                                alt={screenShot?.description || `Screenshot ${i}`}
                                                src={screenShot.image.sourceUrl}
                                            />
                                        </StyledBox>
                                    ))}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
            </Box>
        </>
    );
};
